import component from "./ProfileDeleteAttention.vue"

import wrapVueComponent from "@/utils/wrapVueComponent"
const componentName = "StudentProfileDeleteAttention"

export default wrapVueComponent(componentName, component)
